const importers = {};
const lazyi18nextBackend = ()=>({
        type: 'backend',
        init (services, backendOptions, i18nextOptions) {
        /* use services and options */ },
        read (language, namespace, callback) {
            if (importers[namespace]) {
                importers[namespace](language, namespace, callback);
            } else {
                // eslint-disable-next-line no-console
                console.error('Failed to lazyload resource, did you make a typo in useTranslation()?', namespace, language);
            }
        },
        addImporter: (ns, func)=>{
            importers[ns] = func;
        },
        hasImporter: (ns)=>{
            return importers.hasOwnProperty(ns);
        }
    });
export default lazyi18nextBackend;
